// Form validation for Technician Group form
import { plaintextValidator, urlValidator } from '../fields';

export default {
  entityId: plaintextValidator({ mandatory: true }),
  certificate: plaintextValidator({ mandatory: true }),
  idpLoginUrl: urlValidator({ mandatory: true })
};
